import { collection, query } from "firebase/firestore";
import { db } from "@poseidon/firebase/firebase";
import { useEffect, useState } from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { mapSailor } from "../util/mapSailor";

export const useSailors = () => {
  const [sailors, setSailors] = useState([]);
  const [value, loading, error] = useCollection(
    query(collection(db, "sailors"))
  );
  useEffect(() => {
    const run = async () => {
      if (value) {
        const docs = await Promise.all(value.docs.map((doc) => mapSailor(doc)));
        setSailors(docs);
      }
    };
    run();
  }, [value]);

  return { sailors, loading, error };
};
